<app-filter [tableName]="'asociarTX'"></app-filter>

<app-table [tableName]="'asociarTX'"></app-table>
